module.exports = __webpack_public_path__ + "img/compact.55fa6c70.png";